import './App.css';
import Menu from "./components/Menu";

function App() {
  return (
    <div className="App">
        <h1>My Portfolio</h1>

        there is nothing here.
        <Menu />
    </div>
  );
}

export default App;
